package com.eladfinish.bible.contest.screens.mikud.model

import kotlinx.collections.immutable.ImmutableList
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

typealias LocalMikudMap = Map<String, List<Int>>
typealias MikudData = ImmutableList<BookState>

typealias RemoteMikudMap = Map<String, RemoteMikud>

@Serializable
data class RemoteMikud(
    @SerialName("name") val name: String,
    @SerialName("info") private val _info: String?,
    @SerialName("createdAt") val createdAt: Long, //dateInMillis
    @SerialName("mikudContent") val mikudContent: RemoteMikudContent,
) {
    val info: String
        get() = _info.orEmpty()
}

typealias RemoteMikudContent = Map<String, List<JsonElement>>

enum class MikudSelection {
    ALL,
    NONE,
    ;

    fun toBoolean(): Boolean =
        when (this) {
            ALL -> true
            NONE -> false
        }

    companion object {
        fun fromBoolean(bool: Boolean): MikudSelection =
            when (bool) {
                true -> ALL
                false -> NONE
            }
    }
}
